import React from "react";
import { Tabs } from "antd";
import AttendanceQRCodeMain from "./AttendanceQRCodeMain";
import AttendanceOTPage from "./AttendanceOTPage";
import { ClockCircleOutlined, TeamOutlined } from "@ant-design/icons";

const AttendanceQRcodePage = (props) => {
  const { hideOTTab, ...restProps } = props;

  const items = [
    {
      key: "1",
      label: (
        <span>
          <TeamOutlined />
          <span>ការគ្រប់គ្រងស្កែនវត្តមានបុគ្គលិក</span>
        </span>
      ),
      children: <AttendanceQRCodeMain {...restProps} />,
    },
  ];

  if (!hideOTTab) {
    items.push({
      key: "2",
      label: (
        <span>
          <ClockCircleOutlined />
          <span>ការគ្រប់គ្រងស្កែនវត្តមានបុគ្គលិកបន្ថែមម៉ោង ឬវេន</span>
        </span>
      ),
      children: <AttendanceOTPage {...restProps} />,
    });
  }

  return (
    <div style={{ padding: "0 24px" }}>
      <Tabs defaultActiveKey="1" items={items} />
    </div>
  );
};

export default AttendanceQRcodePage;
